import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ArrowLeftIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="arrow left icon">
      {/* <title>arrow left icon</title> */}
      <path
        d="M1.8343 7.43486L5.0343 4.23486C5.3468 3.92236 5.85305 3.92236 6.16555 4.23486C6.47805 4.54736 6.47805 5.05361 6.16555 5.36611L4.33243 7.19986H13.5999C14.0422 7.19986 14.3999 7.55761 14.3999 7.99986C14.3999 8.44211 14.0422 8.79986 13.5999 8.79986H4.33243L6.16693 10.6344C6.47943 10.9469 6.47943 11.4531 6.16693 11.7656C5.85468 12.0779 5.34843 12.0784 5.03568 11.7656L1.83568 8.56561C1.5218 8.25236 1.5218 7.74736 1.8343 7.43486Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default ArrowLeftIcon;
